angular.module("kareo.ui.shared.directives.tour-card", [
  "kareo.ui.tour",
  'kareo.ui.shared.modules.erx-wizard'
])

.controller("TourCardController", [
  "$scope", "$window", 'ErxWizard', "$timeout"
  ($scope, $window, ErxWizard, $timeout) ->
    switch $scope.tourName
      when 'erx' then $scope.tourSrc = "templates/tour-card/tour-card-erx.html"
      when 'patientupload' then $scope.tourSrc = "templates/tour-card/tour-card-patientupload.html"
      else
        $scope.tourSrc = "templates/tour-card/tour-card-demo.html"

    $scope.toggleTour = ->
      if ($scope.tourName == 'erx')
        ErxWizard.open()
      else if ($scope.tourName == 'patientupload')
        $window.location.href = '/admin-ui/#/admin/importDemographics/view1'
      else
        if $scope.startTourCallback instanceof Function
          $scope.startTourCallback()

        if ($scope.showTour)
          $scope.showTour = false
          $timeout (->
            $scope.showTour = true
            return
          ), 0, false
          return
        else
          $scope.showTour = true

])

.directive 'tourCard', () ->
  restrict: 'E',
  replace: true,
  scope: {
    tourName: '@',
    showTour: '=?',
    endTourCallback: '=?',
    startTourCallback: '=?'
  },
  controller: 'TourCardController',
  template: require('./tour-card.pug')()
